export const DefaultItemWidthDesktop = 340 + 30;
export const DefaultItemWidthMobile = 162 + 25;
export const MaxCarouselWidth = 1460;
export const MaxItems = 4;
